// apps/share-web/src/song-screen/close-song.ts
//
// ✕ телефонного экрана песни: звук останавливается, человек возвращается туда,
// откуда пришёл (решение Сергея 16.10 — без мини-плеера: «вернулся в
// библиотеку — звука нет»). Адрес выводится из ?setlist / ?g, а не из истории:
// смена песни в сетлисте делает pushState (main.ts), и history.back() вёл бы на
// прошлую песню.

const ID_RE = /^[a-zA-Z0-9-]{1,64}$/;   // то же, что проверяет main.ts для ?setlist
// Гостевой адрес /s/<id> роутер принимает только для UUID (GUEST_SETLIST_PATH_RE в
// router.ts, форма та же) — для любого другого id с `g` ведём на экран сетлиста.
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function closeTarget(search: string): string {
  const q = new URLSearchParams(search);
  const sl = q.get('setlist');
  if (sl && ID_RE.test(sl)) {
    const g = q.get('g');
    return g && UUID_RE.test(sl)
      ? `/s/${encodeURIComponent(sl)}?g=${encodeURIComponent(g)}`
      : `/setlist/${encodeURIComponent(sl)}`;
  }
  return '/library';
}

export interface CloseSongDeps {
  player: { pause(): void; isPlaying(): boolean };
  /** Шов для тестов; по умолчанию location.assign (полная загрузка, как у всех переходов веба). */
  navigate?: (path: string) => void;
  search?: string;
}

export function closeSong(d: CloseSongDeps): void {
  if (d.player.isPlaying()) d.player.pause();
  const search = d.search ?? (typeof location !== 'undefined' ? location.search : '');
  const go = d.navigate ?? ((p: string) => { location.assign(p); });
  go(closeTarget(search));
}
